import { Route } from 'vue-router';
import { getFromSessionStorage, hasPayload } from '@/apps/order/helper';
import ordersCreateRouter, { CONTEXT } from '@/apps/order/routes/ordersCreate';

const ensureRelocationData = async (to: Route): Promise<void> => new Promise<void>(async (resolve, reject) => {
  // Only check for relocation mode
  if (to.meta?.mode !== 'relocation') {
    resolve();
    return;
  }

  const ctx = to.meta?.ctx as string || CONTEXT;

  // Check CONTRACT_DATA (window or session); empty server payload `[]` is truthy — hasPayload stops that masking "no data".
  const windowState = window as unknown as { CONTRACT_DATA?: Record<string, any> };
  let contractData = hasPayload(windowState.CONTRACT_DATA) ? windowState.CONTRACT_DATA : undefined;

  // If not in window, try IDB (for reload scenarios)
  if (!contractData) {
    const idbKey = `${ctx}.contractData`;
    const storedContractData = getFromSessionStorage<Record<string, any>>(idbKey);
    contractData = hasPayload(storedContractData) ? storedContractData : undefined;

    // If found in IDB, restore it to window for other code that expects it there
    if (contractData) {
      windowState.CONTRACT_DATA = contractData;
    }
  }

  // If we're on the initial route, allow it (RelocationView will handle initialization)
  if (to.name === 'orders-relocation') {
    resolve();
    return;
  }

  // Without CONTRACT_DATA off the initial route, redirect there to initialize data
  if (!contractData) {
    const initialRoute = ordersCreateRouter.getRoutes().find((route) => route.name === 'orders-relocation');

    if (initialRoute) {
      const error = new Error(`to:${initialRoute.name}`);
      // Preserve contractUuid and store intended route for redirect after initialization
      if (to.params.contractUuid) {
        (error as any).params = { contractUuid: to.params.contractUuid };
      }
      // Store the intended route name so RelocationView can redirect there after initialization
      if (to.name) {
        sessionStorage.setItem('relocationIntendedRoute', to.name as string);
        sessionStorage.setItem('relocationIntendedParams', JSON.stringify(to.params));
      }
      reject(error);
      return;
    }
  }

  resolve();
});

export default ensureRelocationData;
